import {useInfiniteQuery, useQuery} from "@tanstack/react-query";
import * as api from "../../../api";


const PAGE_SIZE = 50;

export const useProvincesInfiniteQuery = (filter, enabled=true) => {
    return useInfiniteQuery({
        queryKey: ['provinces', filter],
        queryFn: async ({pageParam=0}) => {
            const data = await api.Territory.getProvinces({...filter, page_index: pageParam, page_size: PAGE_SIZE});
            return {
                items: data.rows,
                nextPage: data.rows.length === PAGE_SIZE ? pageParam + 1 : undefined,
            };
        },
        getNextPageParam: (lastPage) => lastPage.nextPage,
        enabled: enabled,
    });
}

export const useProvinceQuery = (provinceId, options) => {
    return useQuery({
        queryKey: ['province', provinceId],
        queryFn: async () => {
            const data = await api.Territory.getProvince(provinceId);
            return data;
        },
        enabled: provinceId !== null && provinceId !== undefined,
        ...options
    })
};